import { PendingReport } from '../../interfaces';

export type CanceledReport = PendingReport;

export enum CANCEL_REPORT_BUSINESS_ERRORS {
  REPORT_NOT_FOUND = 'REPORT_NOT_FOUND'
}

export type HandleCancelReportRequest = (id: string) => Promise<Response>;
export type HandleOpenCancelDialog = (item: CanceledReport) => void;
